





























































































import Vue, { PropType } from 'vue'
import { Multimedia } from '@/model/Multimedia'

export default Vue.extend({
  name: 'ProjectFormMultimedia',
  props: {
    multimedia: {
      type: Array,
    },
    mainImage: {
      type: Object as PropType<Multimedia>,
    },
  },
  data: () => ({}),
})
